import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { PageInfoProps } from './type'

import { twMerge } from '@/lib/twMerge'

export const PageInfo = ({
  totalCount,
  perPage,
  page,
  className,
}: PageInfoProps) => {
  const { from, to } = useMemo(() => {
    const from = perPage * (page - 1) + 1
    const to = Math.min(perPage * page, totalCount)
    return { from, to }
  }, [perPage, page, totalCount])

  const { t } = useTranslation()

  if (page < 1) return null

  if (totalCount === 0) {
    return (
      <p
        className={twMerge(
          clsx('tw-w-full tw-text-center tw-text-sm'),
          className
        )}
      >{`${t('common.pagination.fromTo', {
        total: 0,
        from: 0,
        to: 0,
      })}`}</p>
    )
  }

  if (totalCount < from) return null

  return (
    <p
      className={twMerge(
        clsx('tw-w-full tw-text-center tw-text-sm'),
        className
      )}
    >{`${t('common.pagination.fromTo', {
      total: totalCount,
      from,
      to,
    })}`}</p>
  )
}
